const baseURL = "http://www.hanbric.com";
//const baseURL = 'http://192.168.1.102:8022'
export default {
  baseURL
};
